module.exports = __webpack_public_path__ + "780a1d4fa06ca2918a181483528b65ae.swf";


//////////////////
// WEBPACK FOOTER
// ./~/_file-loader@0.10.1@file-loader!./~/_video.js@5.20.5@video.js/dist/video-js.swf
// module id = 768
// module chunks = 1